export const GoldPackage = (): JSX.Element => {
  return (
    <div className="flex w-[334px] h-[1313.67px] items-center justify-center relative transition-transform duration-250 lg:hover:scale-[1.025]">
      {/* Main Package Container */}
      <div className="flex flex-col w-[334px] h-[1313.67px] items-center justify-center gap-[11px] px-0 py-[30px] relative rounded-[40px] border border-dashed border-[#657d84]">
        {/* Package Header */}
        <div className="flex flex-col items-center justify-center gap-4 relative self-stretch w-full flex-[0_0_auto]">
          {/* Icon Circle */}
          <div className="relative w-[90px] h-[90px] bg-[#b7f5f3] rounded-[500px]">
            <img
              className="absolute w-[34px] h-11 top-[23px] left-7"
              alt="Icon icon"
              src="/img/iconicon.png"
            />
          </div>

          {/* Package Title */}
          <div className="inline-flex flex-col items-center justify-center relative flex-[0_0_auto]">
            <div className="relative self-stretch mt-[-1.00px] font-packages-title font-[number:var(--packages-title-font-weight)] text-[#657d84] text-[length:var(--packages-title-font-size)] text-center tracking-[var(--packages-title-letter-spacing)] leading-[var(--packages-title-line-height)] [font-style:var(--packages-title-font-style)]">
              Gold
            </div>
          </div>

          {/* Discount Tag */}
          <div className="relative w-[202px] h-[43px]">
            <div className="relative w-[200px] h-[43px] rounded-[40px]">
              <div className="absolute w-[200px] h-[43px] top-0 left-0 bg-[#566167] rounded-[40px] opacity-90" />
              <div className="absolute w-[69px] h-[19px] top-[11px] left-[66px] font-packages-discount font-[number:var(--packages-discount-font-weight)] text-neutral-100 text-[length:var(--packages-discount-font-size)] text-center tracking-[var(--packages-discount-letter-spacing)] leading-[var(--packages-discount-line-height)] [font-style:var(--packages-discount-font-style)]">
                £400 OFF
              </div>
            </div>
          </div>

          {/* Package Description */}
          <div className="flex flex-col w-[330px] h-8 items-start relative">
            <div className="flex flex-col items-center pl-[54.48px] pr-[54.49px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
              <p className="relative self-stretch mt-[-1.00px] font-packages-description font-[number:var(--packages-description-font-weight)] [font-style:var(--packages-description-font-style)] text-[#657d84] text-[length:var(--packages-description-font-size)] text-center tracking-[var(--packages-description-letter-spacing)] leading-[var(--packages-description-line-height)]">
                30 Minute Film &amp; Highlights
              </p>
            </div>
          </div>
        </div>

        {/* First Divider */}
        <div className="flex flex-col h-[28.89px] items-center justify-center relative self-stretch w-full">
          <div className="flex flex-col items-center pl-[39.95px] pr-[39.96px] pt-0.5 pb-[3.89px] relative self-stretch w-full flex-[0_0_auto] mt-[-3.00px] mb-[-3.00px]">
            <div className="relative self-stretch mt-[-1.00px] [font-family:'Open_Sans',Helvetica] font-normal text-[#ffe1b8] text-[17px] text-center tracking-[0] leading-[28.9px]">
              ........................................................
            </div>
          </div>
        </div>

        {/* Features List */}
        <div className="relative w-[185.77px] h-[291px]">
          {/* Party Feature */}
          <div className="absolute w-[183px] h-[33px] top-[258px] left-0.5">
            <div className="relative w-[197px] h-[33px] -left-2.5">
              {/* Active State */}
              <div className="absolute w-[183px] h-[33px] top-0 left-2.5">
                <img
                  className="left-0 absolute w-[25px] h-8 top-px"
                  alt="Asset"
                  src="/img/asset-59.png"
                />
                <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[43px]">
                  <div className="flex flex-col items-center pl-[21.25px] pr-[21.27px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                    <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                      Party
                    </div>
                  </div>
                </div>
              </div>

              {/* Inactive State with Overlay */}
              <div className="absolute w-[197px] h-[33px] top-0 left-0">
                <div className="relative h-[33px]">
                  <img
                    className="left-2.5 absolute w-[25px] h-8 top-px"
                    alt="Asset"
                    src="/img/asset-59-1.png"
                  />
                  <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[53px]">
                    <div className="flex flex-col items-center pl-[21.25px] pr-[21.27px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                      <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#d8dbdd] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                        Party
                      </div>
                    </div>
                  </div>
                  <div className="absolute w-[197px] h-0.5 top-[15px] left-0 bg-[#d8dbdd]" />
                </div>
              </div>
            </div>
          </div>

          {/* Cake & Dance Feature */}
          <div className="absolute w-[181px] h-8 top-[215px] left-[3px]">
            <div className="relative h-8">
              <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[41px]">
                <div className="flex flex-col items-center pl-[12.34px] pr-[12.36px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                  <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                    Cake &amp; Dance
                  </div>
                </div>
              </div>
              <img
                className="absolute w-[23px] h-[25px] top-[3px] left-0"
                alt="Asset"
                src="/img/asset-13.png"
              />
            </div>
          </div>

          {/* Speeches Feature */}
          <div className="absolute w-[183px] h-8 top-[172px] left-0.5">
            <div className="relative h-8">
              <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[43px]">
                <div className="flex flex-col items-center pl-[30.69px] pr-[30.68px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                  <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                    Speeches
                  </div>
                </div>
              </div>
              <img
                className="absolute w-[25px] h-[26px] top-[3px] left-0"
                alt="Asset"
                src="/img/asset-63.png"
              />
            </div>
          </div>

          {/* Photos & Fizz Feature */}
          <div className="absolute w-[184px] h-8 top-[129px] left-0.5">
            <div className="relative h-8">
              <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-11">
                <div className="flex flex-col items-center px-[13.86px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                  <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                    Photos &amp; Fizz
                  </div>
                </div>
              </div>
              <img
                className="absolute w-[26px] h-[18px] top-[7px] left-0"
                alt="Asset"
                src="/img/asset-28.png"
              />
            </div>
          </div>

          {/* Ceremony Feature */}
          <div className="absolute w-[175px] h-[34px] top-[85px] left-1.5">
            <div className="relative h-[34px]">
              <div className="flex flex-col w-[140px] h-8 items-start absolute top-px left-[35px]">
                <div className="flex flex-col items-center pl-[27.56px] pr-[27.58px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                  <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                    Ceremony
                  </div>
                </div>
              </div>
              <img
                className="absolute w-[17px] h-[34px] top-0 left-0"
                alt="Asset"
                src="/img/asset-46.png"
              />
            </div>
          </div>

          {/* Bride Prep Feature */}
          <div className="absolute w-[181px] h-8 top-[43px] left-[3px]">
            <div className="relative h-8">
              <img
                className="absolute w-[22px] h-6 top-1 left-0"
                alt="Asset"
                src="/img/asset-9.png"
              />
              <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[41px]">
                <div className="flex flex-col items-center px-[25.61px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                  <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                    Bride Prep
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Groom Prep Feature */}
          <div className="absolute w-[186px] h-8 top-0 left-0">
            <div className="relative w-[197px] h-8 -left-2.5">
              {/* Active State */}
              <div className="absolute w-[186px] h-8 top-0 left-2.5">
                <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[46px]">
                  <div className="flex flex-col items-center pl-[19.33px] pr-[19.34px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                    <div className="text-[#657d84] relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                      Groom Prep
                    </div>
                  </div>
                </div>
                <img
                  className="left-0 absolute w-[27px] h-[25px] top-1"
                  alt="Asset"
                  src="/img/asset-44.png"
                />
              </div>

              {/* Inactive State with Overlay */}
              <div className="absolute w-[197px] h-8 top-0 left-0">
                <div className="relative h-8">
                  <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-14">
                    <div className="flex flex-col items-center pl-[19.33px] pr-[19.34px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                      <div className="text-[#d8dbdd] relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                        Groom Prep
                      </div>
                    </div>
                  </div>
                  <img
                    className="left-2.5 absolute w-[27px] h-[25px] top-1"
                    alt="Asset"
                    src="/img/asset-44-1.png"
                  />
                  <div className="absolute w-[197px] h-0.5 top-[15px] left-0 bg-[#d8dbdd]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Divider */}
        <div className="flex flex-col h-[28.89px] items-start relative self-stretch w-full">
          <div className="flex flex-col items-center pl-[51.11px] pr-[51.12px] pt-0.5 pb-[3.89px] relative self-stretch w-full flex-[0_0_auto] mb-[-6.00px]">
            <div className="relative self-stretch mt-[-1.00px] [font-family:'Open_Sans',Helvetica] font-normal text-[#ffe1b8] text-[17px] text-center tracking-[0] leading-[28.9px]">
              ...................................................
            </div>
          </div>
        </div>

        {/* Additional Features */}
        <div className="inline-flex flex-col items-center justify-center gap-3 relative flex-[0_0_auto]">
          {/* Online Gallery Feature */}
          <div className="relative w-[185px] h-8">
            <div className="relative h-8">
              <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[45px]">
                <div className="flex flex-col items-center px-[10.28px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                  <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                    Online Gallery
                  </div>
                </div>
              </div>
              <img
                className="absolute w-[27px] h-[23px] top-1 left-0"
                alt="Asset"
                src="/img/asset-22.png"
              />
            </div>
          </div>

          {/* Highlights Film Feature */}
          <div className="relative w-[185px] h-8">
            <div className="relative h-8">
              <div className="flex flex-col w-36 h-8 items-start absolute top-0 left-[41px]">
                <div className="flex flex-col items-center pl-[4.02px] pr-[4.03px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                  <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                    Highlights Film
                  </div>
                </div>
              </div>
              <img
                className="absolute w-[25px] h-[26px] top-[3px] left-0"
                alt="Fy menu logo"
                src="/img/fymenulogo.png"
              />
            </div>
          </div>

          {/* Drone Footage Feature */}
          <div className="relative w-[181px] h-8">
            <div className="relative w-[197px] h-8 -left-2.5">
              <div className="absolute w-[181px] h-8 top-0 left-2.5">
                <img
                  className="left-0 absolute w-[21px] h-[25px] top-[3px]"
                  alt="Asset"
                  src="/img/asset-5.png"
                />
                <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[41px]">
                  <div className="flex flex-col items-center px-[8.25px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                    <div className="text-[#657d84] relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                      Drone Footage
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute w-[197px] h-8 top-0 left-0">
                <div className="relative h-8">
                  <img
                    className="left-2.5 absolute w-[21px] h-[25px] top-[3px]"
                    alt="Asset"
                    src="/img/asset-5-1.png"
                  />
                  <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[51px]">
                    <div className="flex flex-col items-center px-[8.25px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                      <div className="text-[#d8dbdd] relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                        Drone Footage
                      </div>
                    </div>
                  </div>
                  <div className="absolute w-[197px] h-0.5 top-[15px] left-0 bg-[#d8dbdd]" />
                </div>
              </div>
            </div>
          </div>

          {/* Interviews Feature */}
          <div className="relative w-[186px] h-8">
            <div className="relative w-[197px] h-8 -left-2.5">
              <div className="absolute w-[186px] h-8 top-0 left-2.5">
                <img
                  className="left-0 absolute w-[27px] h-7 top-0.5"
                  alt="Asset"
                  src="/img/asset-39.png"
                />
                <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[46px]">
                  <div className="flex flex-col items-center pl-[26.72px] pr-[26.73px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                    <div className="text-[#657d84] relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                      Interviews
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute w-[197px] h-8 top-0 left-0">
                <div className="relative h-8">
                  <img
                    className="left-2.5 absolute w-[27px] h-7 top-0.5"
                    alt="Asset"
                    src="/img/asset-39-1.png"
                  />
                  <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-14">
                    <div className="flex flex-col items-center pl-[26.72px] pr-[26.73px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                      <div className="text-[#d8dbdd] relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                        Interviews
                      </div>
                    </div>
                  </div>
                  <div className="absolute w-[197px] h-0.5 top-[15px] left-0 bg-[#d8dbdd]" />
                </div>
              </div>
            </div>
          </div>

          {/* Performance Feature */}
          <div className="relative w-[184px] h-8">
            <div className="relative w-[197px] h-8 -left-2.5">
              <div className="absolute w-[184px] h-8 top-0 left-2.5">
                <img
                  className="left-0 absolute w-[25px] h-[30px] top-px"
                  alt="Asset"
                  src="/img/asset-50.png"
                />
                <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-11">
                  <div className="flex flex-col items-center pl-[16.06px] pr-[16.08px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                    <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                      Performance
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute w-[197px] h-8 top-0 left-0">
                <div className="relative h-8">
                  <img
                    className="left-2.5 absolute w-[25px] h-[30px] top-px"
                    alt="Asset"
                    src="/img/asset-50-1.png"
                  />
                  <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[54px]">
                    <div className="flex flex-col items-center pl-[16.06px] pr-[16.08px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                      <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#d8dbdd] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                        Performance
                      </div>
                    </div>
                  </div>
                  <div className="absolute w-[197px] h-0.5 top-[15px] left-0 bg-[#d8dbdd]" />
                </div>
              </div>
            </div>
          </div>

          {/* Social Reels Feature */}
          <div className="relative w-[186px] h-8">
            <div className="relative w-[197px] h-8 -left-2.5">
              <div className="absolute w-[186px] h-8 top-0 left-2.5">
                <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-[46px]">
                  <div className="flex flex-col items-center pl-[20.64px] pr-[20.66px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                    <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                      Social Reels
                    </div>
                  </div>
                </div>
                <img
                  className="left-0.5 absolute w-[23px] h-[23px] top-[5px] object-cover"
                  alt="Component"
                  src="/img/component-1.png"
                />
              </div>

              <div className="absolute w-[197px] h-8 top-0 left-0">
                <div className="relative h-8">
                  <div className="flex flex-col w-[140px] h-8 items-start absolute top-0 left-14">
                    <div className="flex flex-col items-center pl-[20.64px] pr-[20.66px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                      <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#d8dbdd] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                        Social Reels
                      </div>
                    </div>
                  </div>
                  <img
                    className="left-3 absolute w-[23px] h-[23px] top-[5px] object-cover"
                    alt="Component"
                    src="/img/component-1-1.png"
                  />
                  <div className="absolute w-[197px] h-0.5 top-[15px] left-0 bg-[#d8dbdd]" />
                </div>
              </div>
            </div>
          </div>

          {/* Raw Files Feature */}
          <div className="relative w-[182px] h-[33px]">
            <div className="relative w-[197px] h-[33px] -left-2.5">
              <div className="absolute w-[182px] h-[33px] top-0 left-2.5">
                <img
                  className="left-0 absolute w-[23px] h-[33px] top-0"
                  alt="Asset"
                  src="/img/asset-21.png"
                />
                <div className="flex flex-col w-[140px] h-8 items-start absolute top-px left-[42px]">
                  <div className="flex flex-col items-center px-[29.56px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                    <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#657d84] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                      Raw Files
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute w-[197px] h-[33px] top-0 left-0">
                <div className="relative h-[33px]">
                  <img
                    className="left-2.5 absolute w-[23px] h-[33px] top-0"
                    alt="Asset"
                    src="/img/asset-21-1.png"
                  />
                  <div className="flex flex-col w-[140px] h-8 items-start absolute top-px left-[52px]">
                    <div className="flex flex-col items-center px-[29.56px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-85">
                      <div className="relative self-stretch mt-[-1.00px] font-packages-feature font-[number:var(--packages-feature-font-weight)] text-[#d8dbdd] text-[length:var(--packages-feature-font-size)] text-center tracking-[var(--packages-feature-letter-spacing)] leading-[var(--packages-feature-line-height)] [font-style:var(--packages-feature-font-style)]">
                        Raw Files
                      </div>
                    </div>
                  </div>
                  <div className="absolute w-[197px] h-0.5 top-[15px] left-0 bg-[#d8dbdd]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Final Divider */}
        <div className="flex flex-col h-[28.89px] items-start relative self-stretch w-full">
          <div className="flex flex-col items-center pl-[51.11px] pr-[51.12px] pt-0.5 pb-[3.89px] relative self-stretch w-full flex-[0_0_auto] mb-[-6.00px]">
            <div className="relative self-stretch mt-[-1.00px] [font-family:'Open_Sans',Helvetica] font-normal text-[#ffe1b8] text-[17px] text-center tracking-[0] leading-[28.9px]">
              ...................................................
            </div>
          </div>
        </div>

        {/* Price Section */}
        <div className="flex flex-col items-center justify-center gap-[38px] relative self-stretch w-full flex-[0_0_auto]">
          <div className="flex flex-col h-9 items-start relative self-stretch w-full">
            <div className="relative self-stretch w-full h-9 opacity-50">
              <div className="relative w-[82px] h-9 -top-px left-[126px]">
                <div className="absolute w-20 h-9 top-0 left-px font-packages-oldprice font-[number:var(--packages-oldprice-font-weight)] text-[#d8dbdd] text-[length:var(--packages-oldprice-font-size)] text-center tracking-[var(--packages-oldprice-letter-spacing)] leading-[var(--packages-oldprice-line-height)] [font-style:var(--packages-oldprice-font-style)]">
                  £1,995
                </div>
                <div className="absolute w-[82px] h-0.5 top-[19px] left-0 bg-[#d8dbdd]" />
              </div>
            </div>
          </div>

          <div className="relative self-stretch font-packages-newprice font-[number:var(--packages-newprice-font-weight)] text-[#566167] text-[length:var(--packages-newprice-font-size)] text-center tracking-[var(--packages-newprice-letter-spacing)] leading-[var(--packages-newprice-line-height)] [font-style:var(--packages-newprice-font-style)]">
            £1,595
          </div>

          <div className="flex flex-col h-[50px] items-start relative self-stretch w-full">
            <div className="flex flex-col items-center px-[60.44px] py-0 relative self-stretch w-full flex-[0_0_auto] opacity-50">
              <p className="relative w-[280px] mt-[-1.00px] ml-[-33.44px] mr-[-33.44px] font-packages-permonthprice font-[number:var(--packages-permonthprice-font-weight)] text-[#657d84] text-[length:var(--packages-permonthprice-font-size)] text-center tracking-[var(--packages-permonthprice-letter-spacing)] leading-[var(--packages-permonthprice-line-height)] [font-style:var(--packages-permonthprice-font-style)]">
                <span className="tracking-[var(--packages-permonthprice-letter-spacing)] font-packages-permonthprice [font-style:var(--packages-permonthprice-font-style)] font-[number:var(--packages-permonthprice-font-weight)] leading-[var(--packages-permonthprice-line-height)] text-[length:var(--packages-permonthprice-font-size)]">
                  or from{" "}
                </span>
                <span className="font-bold tracking-[var(--packages-permonthprice-letter-spacing)] underline font-packages-permonthprice [font-style:var(--packages-permonthprice-font-style)] leading-[var(--packages-permonthprice-line-height)] text-[length:var(--packages-permonthprice-font-size)]">
                  £79
                </span>
                <span className="tracking-[var(--packages-permonthprice-letter-spacing)] font-packages-permonthprice [font-style:var(--packages-permonthprice-font-style)] font-[number:var(--packages-permonthprice-font-weight)] leading-[var(--packages-permonthprice-line-height)] text-[length:var(--packages-permonthprice-font-size)]">
                  {" "}per month
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 